import React, { useState } from "react";
import {
    AppBar,
    Toolbar,
    IconButton,
    Typography,
    Menu,
    MenuItem,
    Box,
    Button,
    useMediaQuery
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useNavigate, useLocation, Link, Outlet } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const navItems = [
    { label: "Dashboard", path: "/admin/dashboard" },
    { label: "Orders", path: "/admin/getOrders" },
    { label: "Create Order", path: "/admin/createOrder" },
    { label: "Users", path: "/admin/getUsers" },
    { label: "Scrap Rates", path: "/admin/getScrapRate" },
    { label: "Create a Sub-Admin", path: "/admin/createSubadmin" },
    { label: "Recent Transactions", path: "/admin/recentTransactions" },
];

const Layout = () => {
    const navigate = useNavigate();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    const location = useLocation();
    const [anchorEl, setAnchorEl] = useState(null);
    const [userMenuAnchor, setUserMenuAnchor] = useState(null);

    const open = Boolean(anchorEl);
    const userMenuOpen = Boolean(userMenuAnchor);
    const isDashboard = location.pathname === "/admin/dashboard";

    const user = JSON.parse(sessionStorage.getItem("user"));
    const handleMenuClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => setAnchorEl(null);

    const handleUserIconClick = (event) => {
        setUserMenuAnchor(event.currentTarget);
    };

    const handleUserMenuClose = () => {
        setUserMenuAnchor(null);
    };

    const handleLogout = () => {
        sessionStorage.clear();
        handleUserMenuClose();
        navigate("/login");
    };

    const handleChangePassword = () => {
        handleUserMenuClose();
        navigate("/admin/resetPassword");
    };

    return (
        <>
            <AppBar
                position="static"
                sx={{
                    margin: 0,
                    padding: 0,
                    width: "100%",
                    boxShadow: "none",
                    backgroundColor: "#81c784",
                    height: "80px",
                }}
            >
                <Toolbar
                    sx={{
                        margin: 0,
                        padding: "0 20px",
                        minHeight: "80px !important",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                    }}
                >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                        {isDashboard ? (
                            <>
                                <IconButton
                                    edge="start"
                                    color="inherit"
                                    onClick={handleUserIconClick}
                                    sx={{ padding: "6px", fontSize: "24px" }}
                                >
                                    <AccountCircleIcon fontSize="large" />
                                </IconButton>
                                <Menu
                                    anchorEl={userMenuAnchor}
                                    open={userMenuOpen}
                                    onClose={handleUserMenuClose}
                                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                    transformOrigin={{ vertical: "top", horizontal: "left" }}
                                >
                                    <MenuItem onClick={handleChangePassword}>Change Password</MenuItem>
                                    <MenuItem onClick={handleLogout}>Logout</MenuItem>
                                </Menu>
                            </>
                        ) : (
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={() => navigate(-1)}
                                sx={{ padding: "6px", fontSize: "24px" }}
                            >
                                <ArrowBackIcon />
                            </IconButton>
                        )}
                        <Typography variant="h6" sx={{ fontWeight: 500 }}>
                            Admin Panel
                        </Typography>
                    </Box>

                    {isMobile ? (
                        <>
                            <IconButton
                                edge="end"
                                color="inherit"
                                onClick={handleMenuClick}
                            >
                                <MenuIcon />
                            </IconButton>
                            <Menu
                                anchorEl={anchorEl}
                                open={open}
                                onClose={handleClose}
                                anchorOrigin={{
                                    vertical: "bottom",
                                    horizontal: "right",
                                }}
                                transformOrigin={{
                                    vertical: "top",
                                    horizontal: "right",
                                }}
                            >
                                {navItems
                                    .filter(item => {
                                        if (item.label === "Create a Sub-Admin" && user.role !== "admin") {
                                            return false;
                                        }
                                        return true;
                                    })
                                    .map((item) => (
                                        <MenuItem
                                            key={item.label}
                                            onClick={handleClose}
                                            component={Link}
                                            to={item.path}
                                        >
                                            {item.label}
                                        </MenuItem>
                                    ))}
                            </Menu>
                        </>
                    ) : (
                        <Box sx={{ display: "flex", gap: 2 }}>
                            {navItems
                                .filter(item => {
                                    if (item.label === "Create a Sub-Admin" && user.role !== "admin") {
                                        return false;
                                    }
                                    return true;
                                })
                                .map((item) => (
                                    <Button
                                        key={item.label}
                                        color="inherit"
                                        component={Link}
                                        to={item.path}
                                        sx={{
                                            fontSize: "16px",
                                            // borderBottom: location.pathname === item.path
                                            //     ? "2px solid white"
                                            //     : "none",
                                        }}
                                    >
                                        {item.label}
                                    </Button>
                                ))}
                        </Box>
                    )}
                </Toolbar>
            </AppBar>

            <main style={{ margin: 0, padding: 0 }}>
                <Outlet />
            </main>
        </>
    );
};

export default Layout;
